<template>
  <div>
    <template v-if="listField">
      <template v-if="findInputType(listField) === 'lov'">
        <template v-if="findLovType(listField) === 'codcomp'">
          <hrms-lov-codcomp 
                      v-model="listValue"
                      :nowLang="nowLang"
                      v-validate="'required'"
                      data-vv-value-path="inputValue"
                      :data-vv-as="listField"
                      :data-vv-name="listField"
                      :name="listField"
                      :has-error="errors.has(listField)" />
        </template>
        <template v-else-if="findLovType(listField) === 'codsex'">
          <input type="radio" name="male" v-model="listValue" value="M"> <span class="radio-text">{{labelCodsex['M']}}</span>
          <input type="radio" name="female" v-model="listValue" value="F"> <span class="radio-text">{{labelCodsex['F']}}</span>
        </template>
        <template v-else>
          <hrms-lov   v-model="listValue"
                      :nowLang="nowLang"
                      :lovType="findLovType(listField)"
                      v-validate="'required'"
                      data-vv-value-path="inputValue"
                      :data-vv-as="listField"
                      :data-vv-name="listField"
                      :name="listField"
                      :has-error="errors.has(listField)" />
        </template>
      </template>
      <template v-else>
        <template v-if="findValueType(listField) === 'number'">
          <input type="number" v-model="listValue"
                 v-validate="'required'" :data-vv-name="listField"
                 class="text-input"
                 :class="{ 'input-error' : errors.has(listField) }" />
        </template>
        <template v-if="findValueType(listField) === 'varchar2'">
          <input type="text" v-model="listValue"
                 v-validate="'required'" :data-vv-name="listField"
                 class="text-input"
                 :class="{ 'input-error' : errors.has(listField) }" />
        </template>
        <template v-if="findValueType(listField) === 'date'">
          <hrms-datepicker  v-model="listValue" 
                            v-validate="'required|date_format:DD/MM/YYYY'"
                            data-vv-value-path="inputDate"
                            :data-vv-name="listField"
                            :name="listField"
                            :has-error="errors.has(listField)" />
        </template>
      </template>
    </template>
    <template v-else>
      <input type="text" v-model="listValue"
              v-validate="'required'" data-vv-name="listValue"
              class="text-input"
              :class="{ 'input-error' : errors.has('listValue') }" />
    </template>
  </div>
</template>

<script>
export default {
  name: 'hrms-logical-statement-higher-order-value-component',
  data () {
    return {
      listValue: this.value
    }
  },
  watch: {
    listField () {
      this.listValue = ''
    },
    listValue () {
      this.$emit('input', this.listValue)
    }
  },
  props: {
    nowLang: {
      type: String,
      default: 'th'
    },
    listField: {
      type: String,
      required: true
    },
    labelCodsex: {
      type: Object
    },
    value: {
      type: String
    },
    findValueType: {
      type: Function
    },
    findInputType: {
      type: Function
    },
    findLovType: {
      type: Function
    }
  }
}
</script>


// WEBPACK FOOTER //
// higherOrderValueComponent.vue?1d7e3c41